import React from "react";
import { Row, Col } from "antd";
import AdnRate from "../adnRate/AdnRate";
import AdnToolTip from "../adnToolTip/AdnToolTip";

const AdnSatisfactionRate = ({
    companyLevel,
    clientLevel,
    projectLevel,
    disabled,
    style,
    className,
}) => {
    return (
        <>
            <Row>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }} xxl={{ span: 8 }}>
                    <AdnRate
                        name={companyLevel}
                        label={
                            <>
                                Company level
                                <AdnToolTip title="Satisfaction level in Adentis" />
                            </>
                        }
                        disabled={disabled}
                        style={style}
                        className={className}
                    />
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }} xxl={{ span: 8 }}>
                    <AdnRate
                        name={clientLevel}
                        label={
                            <>
                                Client level
                                <AdnToolTip title="Satisfaction level in current client" />
                            </>
                        }
                        disabled={disabled}
                        style={style}
                        className={className}
                    />
                </Col>

                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8 }} lg={{ span: 8 }} xl={{ span: 8 }} xxl={{ span: 8 }}>
                    <AdnRate
                        name={projectLevel}
                        label={
                            <>
                                Project level
                                <AdnToolTip title="Satisfaction level in current project" />
                            </>
                        }
                        disabled={disabled}
                        style={style}
                        className={className}
                    />
                </Col>
            </Row>
            <Row justify="start">
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
                    {!disabled &&
                        <p className="error">Please rate all 3 levels.</p>
                    }
                </Col>
            </Row>
        </>
    );
};

export default AdnSatisfactionRate;